// 单壳 SPA 路由：pathname → 视图函数。链接统一带 data-route，
// 点击时 pushState 并重渲染；popstate（返回键）同样重渲染。
import { portalView } from "./views/portal";
import { englishView } from "./views/english";
import { textbookView } from "./views/textbook";
import { aesopView } from "./views/aesop";
import { playerView } from "./views/player";
import { comingSoonView } from "./views/comingSoon";
import { canonicalPath, PATHS } from "../shared/navigation";

import { razView, razBooksView, razReaderView } from "./views/raz";

import { razAnnotateView } from "./views/raz-annotate";

type SyncView = (root: HTMLElement) => void;
type AsyncView = (root: HTMLElement) => Promise<void>;
type View = SyncView | AsyncView;

const ROUTES: Record<string, View> = {
  [PATHS.home]: portalView,
  [PATHS.english]: englishView,
  [PATHS.textbook2a]: textbookView,
  [PATHS.aesop]: aesopView,
  [PATHS.player]: playerView,
  [PATHS.raz]: razView,
  [PATHS.razA]: razBooksView,
  [PATHS.razAnnotate]: razAnnotateView,
  [PATHS.razReader]: razReaderView,
  [PATHS.chinese]: (root) => comingSoonView(root, "语文"),
  [PATHS.math]: (root) => comingSoonView(root, "数学"),
};

/** 视图切换前清理残留媒体：暂停 audio/video、销毁 Ruffle 实例（否则音乐会在后台一直响）。 */
function cleanupMedia(): void {
  document.querySelectorAll("#app audio, #app video").forEach((m) => {
    try {
      (m as HTMLMediaElement).pause();
    } catch {
      /* 忽略 */
    }
  });
  const player = window.__currentPlayer;
  if (player) {
    // Ruffle 播放器元素重载了 remove()：销毁实例并停掉 Web Audio
    try {
      (player as unknown as { remove?: () => void }).remove?.();
    } catch {
      /* 忽略 */
    }
    window.__currentPlayer = undefined;
  }
  // 兜底：清理页面上任何残留的 ruffle 播放器
  document.querySelectorAll("ruffle-player").forEach((el) => {
    try {
      (el as unknown as { remove?: () => void }).remove?.();
      el.remove();
    } catch {
      /* 忽略 */
    }
  });
}

function render(): void {
  const app = document.getElementById("app");
  if (!app) return;

  cleanupMedia();

  const path = canonicalPath(window.location.pathname);
  if (path !== window.location.pathname) {
    window.history.replaceState(null, "", path + window.location.search + window.location.hash);
  }
  const view = ROUTES[path] ?? portalView; // 未知路径回门户
  if (!ROUTES[path]) {
    window.history.replaceState(null, "", "/");
  }

  document.body.classList.toggle(
    "player-page",
    path === PATHS.player
  );
  app.replaceChildren();
  window.scrollTo(0, 0);
  void view(app);
}

document.addEventListener("click", (e) => {
  if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
    return;
  }
  const target = e.target as HTMLElement | null;
  const anchor = target?.closest("a[data-route]");
  if (!anchor) return;
  const href = anchor.getAttribute("href");
  if (!href) return;
  e.preventDefault();
  if (href === window.location.pathname + window.location.search) {
    return; // 已在当前页
  }
  window.history.pushState(null, "", href);
  render();
});

window.addEventListener("popstate", render);

// Service Worker 由 index.html 尽早注册，避免重复注册覆盖更新配置。

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", render);
} else {
  render();
}
